"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _FormValidator = _interopRequireDefault(require("./FormValidator"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getFormComponents = function getFormComponents(components) {
  var getAllChildrenFields = function getAllChildrenFields(children, fields) {
    [].concat(children).forEach(function (field) {
      if (field && field.props && field.props.children && typeof field.props.children !== 'string') {
        getAllChildrenFields(field.props.children, fields);
      }
      if (field && field.props && field.type && field.type.isFormComponent) {
        fields[field.props.name] = field; // eslint-disable-line no-param-reassign
      }
    });
    return fields;
  };
  return getAllChildrenFields(components, {});
};
var getInitialFieldState = function getInitialFieldState(field, value, values) {
  var fieldValue = value;
  var isFieldDirty = !(value === undefined || value === null);
  var fieldValidationResult = isFieldDirty ? _FormValidator["default"].syncValidate(field, fieldValue, values) : {
    isValid: !field.props.required ? true : undefined,
    errors: {}
  };
  return {
    isFocused: field.props.isFocused,
    isDirty: isFieldDirty,
    value: fieldValue,
    validationResult: fieldValidationResult
  };
};
var getIsFormValid = function getIsFormValid(fieldsState) {
  return Object.keys(fieldsState).reduce(function (prev, curr) {
    return prev && fieldsState[curr].validationResult.isValid;
  }, true);
};
var getIsFormPending = function getIsFormPending(fieldsState) {
  return Object.keys(fieldsState).reduce(function (prev, curr) {
    return prev || !!fieldsState[curr].validationResult.pendingValidations && Object.keys(fieldsState[curr].validationResult.pendingValidations).length > 0;
  }, false);
};
var getInitialFormState = function getInitialFormState(formComponents) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fieldsState = Object.keys(formComponents).reduce(function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, formComponents[key].props.name, getInitialFieldState(formComponents[key], values[key], values)));
  }, {});
  return {
    isValid: getIsFormValid(fieldsState),
    isPending: getIsFormPending(fieldsState),
    meta: fieldsState
  };
};
var getFieldsValues = function getFieldsValues(formMetadata) {
  return Object.keys(formMetadata).reduce(function (acc, fieldKey) {
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, fieldKey, formMetadata[fieldKey].value));
  }, {});
};
var _default = exports["default"] = {
  getFormComponents: getFormComponents,
  getIsFormValid: getIsFormValid,
  getIsFormPending: getIsFormPending,
  getInitialFieldState: getInitialFieldState,
  getInitialFormState: getInitialFormState,
  getFieldsValues: getFieldsValues
};
//# sourceMappingURL=FormUtils.js.map